export type I18nLang = 'fr' | 'en';

export const LANGUAGE_I18N_2_THEME: {[key: string]: string} = {
  fr: 'fr_FR',
  en: 'en'
};

export const LANGUAGE_THEME_2_I18N: {[key: string]: string} = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  fr_FR: 'fr',
  en: 'en'
};
